import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";

function Feedback() {
  return (
    <div className="cards">
      <div className="d-flex justify-content-between">
        <h3 className="f-20 fw-600">Message Analysis</h3>
          <a href="">View all</a>
        <span>
        </span>
      </div>
      <div className="mt-3 hr">
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            <div className="me-3">
              <img
                src={require("../../../../assets/DigitalMarketing/image/dashboard/profilename.png")}
                width={45}
                alt="i"
              />
            </div>
            <div>
              <p className="f-16 mb-0">Anandh</p>
              <p className="f-12 c-grey">Medical Student, Chennai</p>
            </div>
          </div>
          <div className="mt-2">
                    <p className="f-14 c-purple fw-500">Sent on Yesterday </p>
          </div>
        </div>
        <p className="f-16 c-grey">The safe pregnancy blog was my go-to resource during my partner's pregnancy. The practical tips and expert advice made me feel more prepared and involved in the journey."</p>
      </div>
      <div className="mt-3 hr">
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            <div className="me-3">
              <img
                src={require("../../../../assets/DigitalMarketing/image/dashboard/profilename.png")}
                width={45}
                alt="i"
              />
            </div>
            <div>
              <p className="f-16 mb-0">Selvam</p>
              <p className="f-12 c-grey">Medical Student, Chennai</p>
            </div>
          </div>
          <div className="mt-2">
                    <p className="f-14 c-purple fw-500">Sent on Yesterday </p>
          </div>
        </div>
        <p className="f-16 c-grey">The safe pregnancy blog was my go-to resource during my partner's pregnancy. The practical tips and expert advice made me feel more prepared and involved in the journey."</p>
      </div>
    </div>
  );
}

export default Feedback;
